import {useTranslation} from 'react-i18next';
import {Project} from 'interfaces/Project';
import canGenerateReport from '../utils/canGenerateReport';

export default function useReportAvailability(project: Project): {
  canGenerate: boolean;
  disabledReason: string;
} {
  const {t} = useTranslation('common');
  const canGenerate = canGenerateReport(project);
  const disabledReason =
    project.sections.length === 0
      ? t('common:generatePdfNoSections')
      : t('common:generatePdfMissingTray');

  return {canGenerate, disabledReason};
}
